import { IAutomationObject } from '../../types'

export interface ISensorAnalog extends IAutomationObject {
    value: number;
    dimension: string;
    rangeMin: number;
    rangeMax: number;
    isAlarmLow?: boolean;
    isAlarmHigh?: boolean;
    isWarningLow?: boolean;
    isWarningHigh?: boolean;
    enableAlarmLimitLow: boolean;
    enableAlarmLimitHigh: boolean;
    enableWarningLimitLow: boolean;
    enableWarningLimitHigh: boolean;
    alarmLimitLow?: number;
    alarmLimitHigh?: number;
    warningLimitLow?: number;
    warningLimitHigh?: number;
    alarmDelay?: number;
    warningDelay?: number; 
    overridden: boolean;
    outOfService: boolean;
    deadBand?: number,
    onValueChanged: any;
    noSensor: boolean;
    overRange: boolean;
    underRange: boolean;
    openLoop: boolean;
    shortedLoop: boolean;
    communicationFailure: boolean;
}

export interface ILimit {
    enable: boolean;
    value: number;
    onEnableChanged: any;
    onValueChanged: any;
}

export const graces = {
    '°C': 3.0,
    '°F': 3.0,
    '°K': 3.0,
    'default': 0.0,
} as IDictionary
interface IDictionary {
    [index: string]: any;
}

export const schema = 'AutomationApps.Devices.Sensors.SensorAnalog';
export const schemaTemperature = 'AutomationApps.Devices.Sensors.TemperatureSensor';
export const schemaTemperature1 = 'AutomationApps.Devices.Sensors.Temperature1Sensor';
export const schemaTemperature2 = 'AutomationApps.Devices.Sensors.Temperature2Sensor';
export const schemaTemperature3 = 'AutomationApps.Devices.Sensors.Temperature3Sensor';
export const schemaTemperature4 = 'AutomationApps.Devices.Sensors.Temperature4Sensor';
export const schemaTemperature5 = 'AutomationApps.Devices.Sensors.Temperature5Sensor';
export const schemaTemperature6 = 'AutomationApps.Devices.Sensors.Temperature6Sensor';
export const schemaHumidity = 'AutomationApps.Devices.Sensors.HumiditySensor';
export const schemaPressure = 'AutomationApps.Devices.Sensors.PressureSensor';
export const schemaFlowTemperature = 'AutomationApps.Devices.Sensors.FlowTemperatureSensor';
export const schemaOutletTemperature = 'AutomationApps.Devices.Sensors.OutletTemperatureSensor';

export const isAnalogSensor = (schemaInput: string) => {
    return schemaInput === schema ||
    schemaInput === schemaTemperature ||
    schemaInput === schemaTemperature1 ||
    schemaInput === schemaTemperature2 ||
    schemaInput === schemaTemperature3 ||
    schemaInput === schemaTemperature4 ||
    schemaInput === schemaTemperature5 ||
    schemaInput === schemaTemperature6 ||
    schemaInput === schemaHumidity ||
    schemaInput === schemaPressure ||
    schemaInput === schemaFlowTemperature ||
    schemaInput === schemaOutletTemperature
}


